"use client";
import "core-js/modules/es.array.map.js";
import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import Home from "./Home.jsx";
import CompanyProfile from "./CompanyProfile.jsx";
import Notice from "./Notice.jsx";
import Join from "./Join.jsx";
import News from './News';
import NewDetail from './NewDetail'

import DigitalTwin from "../service/DigitalTwin.jsx";
import CloudChain from "../service/CloudChain.jsx";
import AddressManagement from "../service/AddressManagement.jsx";
import SmartPakcing from "../service/SmartPakcing.jsx";
import GISservicePlatform from "../service/GISservicePlatform.jsx";

import "../utils/axios.js";
import "@fontsource/noto-sans-sc"; // 思源黑体
import "@fontsource/noto-serif-sc"; // 思源宋体
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import './../styles/index.css'
import NotFound from './../components/notFound.jsx';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/CompanyProfile" element={<CompanyProfile />} />

        <Route path="/service/digitaltwin" element={<DigitalTwin />} />
        <Route path="/service/cloudchain" element={<CloudChain />} />
        <Route
          path="/service/addressmanagement"
          element={<AddressManagement />}
        />
        <Route path="/service/smartParking" element={<SmartPakcing />} />
        <Route
          path="/service/GIS-servicePlatform"
          element={<GISservicePlatform />}
        />

        <Route path="/Notice" element={<Notice />} />
        <Route path="/Join" element={<Join />} />
        <Route path="/News" element={<News />} />
        <Route path="/NewDetail" element={<NewDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
